import { createRequest } from "helpers/tools";

export const sendDynamicsData = async (data) => {
    return await createRequest({
        suffix: `dynamics`,
        handleError: true,
        method: "post",
        payload: data,
    });
};

export const dynamicsConnectAut = async (data, id) => {
    return await createRequest({
        suffix: `dynamics/connect/${id}`,
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const dynamicsMappingUpdate = async (data, id) => {
    return await createRequest({
        suffix: `dynamics/update/${id}`,
        method: "put",
        payload: data,
        handleError: false,
    });
};

export const getDynamicsMapping = async (id) => {
    return await createRequest({
        suffix: `dynamics/${id}/fields`,
        method: "get",
        handleError: false,
    });
};

export const testDynamics = async (id) => {
    return await createRequest({
        suffix: `dynamics/preview/${id}`,
        method: "get",
        handleError: false,
    });
};

// =============================================================================
// Lead Service - Microsoft Dynamics API Functions
// =============================================================================

/**
 * Store Microsoft Dynamics destination for Lead service
 * Creates a new Dynamics connection and returns auth_url for OAuth flow
 * @param {Object} payload - { crm_url: string, name: string }
 * @returns {Promise} Response with auth_url and destination_id
 */
export const sendDataDynamicsLead = async (payload) => {
    return await createRequest({
        suffix: `lead/service/dynamics/store`,
        handleError: true,
        method: "post",
        payload,
    });
};

/**
 * Complete Microsoft Dynamics OAuth connection for Lead service
 * Called after user completes OAuth flow with code and state from popup
 * @param {number} destinationId - The destination_id from store API
 * @param {Object} payload - { code: string, state: string }
 * @returns {Promise} Response with connection status
 */
export const connectDynamicsLead = async (destinationId, payload) => {
    return await createRequest({
        suffix: `lead/service/dynamics/${destinationId}/connect`,
        handleError: true,
        method: "post",
        payload,
    });
};

/**
 * Get list of existing Microsoft Dynamics destinations for Lead service
 * Used to populate the select dropdown with previously connected Dynamics instances
 * @returns {Promise} Response with array of Dynamics destinations
 */
export const getLeadDynamicsDestinations = async () => {
    return await createRequest({
        suffix: `lead/service/microsoft-dynamics/list`,
        handleError: true,
        method: "get",
    });
};
